import React from 'react'
import { Box } from '@chakra-ui/react'
import View from '../../TreatmentPlan/components/View'

const TreatmentPlan = () => {
  return <View />
}

export default TreatmentPlan
